
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire716c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire716c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $01f40ec057963b01$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["ioUUD","index.7ce358fa.js","3JUCu","alert-shadow.ce776678.svg"]'));

const $f1be1af5826a1cc7$export$de29fd83663c91ec = [
    {
        id: 0,
        text: "Windows 95 is a consumer-oriented operating system developed by Microsoft as part of its Windows 9x family of operating systems."
    },
    {
        id: 1,
        text: 'Windows 95 merged Microsoft"s formerly separate MS-DOS and Microsoft Windows products, and featured significant improvements over its predecessor, most notably in the graphical user interface (GUI) and in its simplified "plug-and-play" features.'
    },
    {
        id: 2,
        text: 'Accompanied by an extensive marketing campaign, Windows 95 introduced numerous functions and features that were featured in later Windows versions, and continue in modern variations to this day, such as the taskbar, notification area, and the "Start" button.'
    },
    {
        id: 3,
        text: "It is considered to be one of the biggest and most important products in the personal computing industry."
    },
    {
        id: 4,
        text: "Three years after its introduction, Windows 95 was followed by Windows 98. Nevertheless, Windows 95 remained the most popular operating system in 1998, despite the release of Windows 98. Microsoft ended mainstream support for Windows 95 on December 31, 2000."
    }
];



function $d2362592c865fe34$export$f8127174200decae(str) {
    const string = str.replace(/\D/g, "");
    return parseInt(string);
}
function $d2362592c865fe34$export$160e12c8879fa3b(newArray, node) {
    const dialogId = parseInt(node.dataset.dialogId);
    //1. Find the index of the clicked dialog
    const dialogIndex = newArray.findIndex((item)=>item.id === dialogId);
    // 2. Remove the clicked dialog oject from the newArray Array
    const removedItem = newArray.splice(dialogIndex, 1);
    // 3. Add the clicked dialog back to the end of the newArray Array
    newArray = [
        ...newArray,
        ...removedItem
    ];
    return newArray;
}
function $d2362592c865fe34$export$b4a93e0b711d8f7(e) {
    e.target.classList.add("mouse-down");
}
function $d2362592c865fe34$export$88f4dbb0cd0ffc84(e) {
    e.target.classList.remove("mouse-down");
}


const $30fcf04e28673cc1$export$a51dbe0a4d12e385 = 300;


let $335df6c00f6a69e7$var$newWikiData = [
    ...(0, $f1be1af5826a1cc7$export$de29fd83663c91ec)
];
function $335df6c00f6a69e7$export$49007c82350623e6(e) {
    const activeDialog = e.target.closest("dialog.dialog");
    // const dialogHeight = activeDialog.offsetHeight
    const dialogHeight = activeDialog.offsetHeight;
    // 1. MOVE THE ACTIVE DIALOG WINDOW
    // Hide the dialog
    activeDialog.style.display = "none";
    // 2. REORDER THE WIKI DATA ARRAY
    // Match the active dialog node to the data array using node.dataset.dialogId, and then create a new array with the active dialog node moved the the end
    $335df6c00f6a69e7$var$newWikiData = (0, $d2362592c865fe34$export$160e12c8879fa3b)($335df6c00f6a69e7$var$newWikiData, activeDialog);
    // Update each dialog node.dataset.dialogIndex to match the index of the newWikiData.
    // Updating the node.dataset.dialogIndex for each node will trigger CSS transitions that move all the nodes forward
    for(let i = 0; i < $335df6c00f6a69e7$var$newWikiData.length; i++){
        const itemId = $335df6c00f6a69e7$var$newWikiData[i].id;
        const domItem = document.querySelector(`[data-dialog-id="${itemId}"]`);
        domItem.dataset.dialogIndex = i;
    }
    // 3. RESET THE STYLE ATTRIBUTE OF THE FORMALLY ACTIVE NODE
    setTimeout(()=>{
        activeDialog.style.zIndex = 1;
        activeDialog.style.left = `-80px`;
        activeDialog.style.top = `-80px`;
        activeDialog.style.display = `block`;
        activeDialog.style = "";
    }, (0, $30fcf04e28673cc1$export$a51dbe0a4d12e385));
}




var $b9c186e3c09db4b5$exports = {};
$b9c186e3c09db4b5$exports = new URL("alert-shadow.ce776678.svg", import.meta.url).toString();


function $cd65db495f781a9b$export$e342f373524b53fa({ id: id, text: text }, index) {
    const dialog = document.createElement("dialog");
    dialog.classList.add("dialog");
    dialog.setAttribute("open", "");
    dialog.setAttribute("data-dialog-id", id);
    dialog.setAttribute("data-dialog-index", index);
    dialog.style.transition = `all ${0, $30fcf04e28673cc1$export$a51dbe0a4d12e385} ease-in-out`;
    const imageUrl = new URL($b9c186e3c09db4b5$exports);
    const wrapper = document.createElement("div");
    wrapper.classList.add("dialog__wrapper");
    dialog.append(wrapper);
    const header = document.createElement("div");
    header.classList.add("dialog__header");
    wrapper.append(header);
    const title = document.createElement("h1");
    title.classList.add("dialog__title", "h5");
    title.innerHTML = `Windows 95 - Part ${id + 1}`;
    header.append(title);
    const closeButton = document.createElement("button");
    closeButton.classList.add("dialog__close", "close-button", "icon", "icon--x-mark");
    closeButton.innerHTML = `<span class="visually-hidden">Close window</span>`;
    closeButton.onmousedown = (0, $d2362592c865fe34$export$b4a93e0b711d8f7);
    closeButton.onmouseup = (0, $d2362592c865fe34$export$88f4dbb0cd0ffc84);
    closeButton.onclick = (0, $335df6c00f6a69e7$export$49007c82350623e6);
    header.append(closeButton);
    const body = document.createElement("div");
    body.classList.add("dialog__body");
    wrapper.append(body);
    const content = document.createElement("div");
    content.classList.add("dialog__content");
    body.append(content);
    const alert = document.createElement("img");
    alert.classList.add("dialog__alert");
    alert.setAttribute("src", imageUrl);
    alert.setAttribute("alt", "alert");
    content.append(alert);
    const textP = document.createElement("p");
    textP.classList.add("dialog__text");
    textP.innerHTML = text;
    content.append(textP);
    const buttonsBox = document.createElement("div");
    buttonsBox.classList.add("dialog__buttons");
    body.append(buttonsBox);
    const okButton = document.createElement("button");
    okButton.classList.add("dialog__ok", "windows-button");
    okButton.onclick = (0, $335df6c00f6a69e7$export$49007c82350623e6);
    okButton.onmousedown = (0, $d2362592c865fe34$export$b4a93e0b711d8f7);
    okButton.onmouseup = (0, $d2362592c865fe34$export$88f4dbb0cd0ffc84);
    okButton.innerHTML = `<div class="button-wrapper">OK</div>`;
    buttonsBox.append(okButton);
    return dialog;
}



function $5c75103dbdd32ea3$export$2e2bcd8739ae039() {
    // On load, create the wiki windows
    const startButton = document.querySelector("button.start-button");
    const wikiSection = document.querySelector(".wiki-section");
    let activeWikis = false;
    startButton.addEventListener("click", ()=>{
        if (activeWikis) {
            // Delete the nodes in the order they appear on the screen
            let wikiNodes = document.querySelectorAll("dialog.dialog");
            wikiNodes.forEach((node, index)=>{
                const toDelete = document.querySelector(`dialog[data-dialog-index="${index}"]`);
                setTimeout(()=>{
                    toDelete.remove();
                }, (index + 1) * 100);
            });
            activeWikis = false;
            wikiNodes = [];
        } else {
            (0, $f1be1af5826a1cc7$export$de29fd83663c91ec).forEach((item, index)=>{
                setTimeout(()=>{
                    wikiSection.append((0, $cd65db495f781a9b$export$e342f373524b53fa)(item, index));
                }, (index + 1) * 100);
            });
            activeWikis = true;
        }
    });
}



function $0f9f5ac162b27c89$export$2e2bcd8739ae039() {
    const buttons = document.querySelectorAll("button");
    buttons.forEach((button)=>{
        button.addEventListener("mousedown", (0, $d2362592c865fe34$export$b4a93e0b711d8f7));
        button.addEventListener("mouseup", (0, $d2362592c865fe34$export$88f4dbb0cd0ffc84));
    });
}


function $879dcfabd4ca9546$export$2e2bcd8739ae039() {
    const timeText = document.querySelector(".time");
    const newDate = new Date();
    const newTime = newDate.toLocaleString("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: true
    });
    timeText.innerHTML = newTime;
    setInterval(()=>{
        timeText.innerHTML = newTime;
    }, 1000);
}


(0, $5c75103dbdd32ea3$export$2e2bcd8739ae039)();
(0, $0f9f5ac162b27c89$export$2e2bcd8739ae039)();
(0, $879dcfabd4ca9546$export$2e2bcd8739ae039)();


//# sourceMappingURL=index.7ce358fa.js.map
